import { registerLocaleData } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import localeEsCR from '@angular/common/locales/es-CR';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

registerLocaleData(localeEsCR, 'es-CR');

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
